module.exports = __webpack_public_path__ + "img/swag-admin-1.64c5550b.png";